import React from "react";

/**
 * EmptyState — friendly empty-state block for v2 home/list surfaces.
 * Props:
 *   icon: string emoji (optional)
 *   title: required
 *   body: supporting prose
 *   action: { label, onClick, kind?: "primary" | "ghost" }
 *   testId
 */
const EmptyState = ({ icon = "✨", title, body, action, testId = "v2-empty" }) => (
  <div className="workspace-empty" data-testid={testId}>
    <div className="workspace-empty__icon" aria-hidden="true">{icon}</div>
    <div className="workspace-empty__title">{title}</div>
    {body && <div className="workspace-empty__body">{body}</div>}
    {action && (
      <button
        type="button"
        className={`workspace-empty__action workspace-empty__action--${action.kind || "primary"}`}
        onClick={action.onClick}
        data-testid={`${testId}-action`}
      >
        {action.label}
      </button>
    )}
  </div>
);

export default EmptyState;
